let baseURL;
if(process.env.NODE_ENV==='development'){//测试环境

    baseURL='https://api.yhbit.cn'
}else{//正式环境
    baseURL='https://api.yhbit.cn'
}
export default baseURL;
